'use client'
import './Accordion.scss';
import { ReactNode, useEffect, useRef, useState } from 'react';

type AccordionProps = {
  header: ReactNode;
  content: ReactNode;
  isActive: boolean;
  onClick: () => void;
  activeKey: string | null;
  accordionKey: string;
};

export const Accordion: React.FC<AccordionProps> = ({
  header,
  content,
  isActive,
  onClick,
  activeKey,
  accordionKey,
}) => {
  const accordionRef = useRef<HTMLElement | null>(null);
  const headerHeightRef = useRef<HTMLDivElement | null>(null);

  const [headerHeight, setHeaderHeight] = useState(0);
  const [accordionHeight, setAccordionHeight]: [string | number, (value: string | number) => void] = useState<
    string | number
  >('auto');
  const [fullAccordionHeight, setFullAccordionHeight] = useState(0);
  const [AccordionIsActive, setAccordionIsActive] = useState(isActive);

  const accordionPadding: number = 20;

  useEffect(() => {
    setAccordionIsActive(accordionKey === activeKey);

    if (accordionKey === activeKey) {
      setAccordionHeight(!AccordionIsActive ? fullAccordionHeight : headerHeight + accordionPadding);
    } else {
      // Close the others accordions
      setAccordionHeight(headerHeight + accordionPadding);
    }
  }, [activeKey]);

  useEffect(() => {
    let measuredHeaderHeight = 0;
    let measuredFullAccordionHeight = 0;

    if (headerHeightRef.current) {
      measuredHeaderHeight = headerHeightRef.current.clientHeight;
      setHeaderHeight(measuredHeaderHeight);
    }

    if (accordionRef.current) {
      measuredFullAccordionHeight = accordionRef.current.clientHeight;
      setFullAccordionHeight(measuredFullAccordionHeight);
    }

    if (measuredHeaderHeight !== 0 && measuredFullAccordionHeight !== 0) {
      setAccordionHeight(AccordionIsActive ? measuredFullAccordionHeight : measuredHeaderHeight + accordionPadding);
    }
  }, []);

  const handleClick = () => {
    onClick();
  };

  return (
    <section
      onClick={handleClick}
      ref={accordionRef}
      style={{ border: '1px solid gray', height: accordionHeight }}
      className={`accordion mt-3 ${AccordionIsActive ? 'is-active' : ''}`}
    >
      <div ref={headerHeightRef} className="accordion__header">
        {header}
      </div>
      <div className="accordion__content">{content}</div>
    </section>
  );
};
